import { render, staticRenderFns } from "./AddEditDesignationsMapping.vue?vue&type=template&id=784684e6&"
import script from "./AddEditDesignationsMapping.vue?vue&type=script&lang=js&"
export * from "./AddEditDesignationsMapping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports